{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Изберете предмет",
  "tableResizer": "Преоразмерител",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
